import React, { Component } from 'react';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';

import DepartmentActions from '../../actions/DepartmentActionCreator';
import DepartmentStore from '../../stores/DepartmentStore';

import { withId } from '../Common/Decorators';
import SelectOrganisation from '../Organisation/SelectOrganisation';

class DepartmentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: {
                id: '',
                name: '',
                description: '',
                organisationId: null,
                organisation: '',
                isDefault: null
            }
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onSelectOrganisation = this.onSelectOrganisation.bind(this);
        this.onSave = this.onSave.bind(this);
        this.listeners = [];

        if (this.props.id) {
            this.listeners.push(DepartmentStore.addListener(this.onChange));
            DepartmentActions.getById(this.props.id);
        }
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        const isEdit = !!this.props.id;

        const formTitle = (isEdit ? 'New department' : `Edit' ${(!!this.state.details.isDefault ? ' (Default Department)' : '')}`);
        const redirectTo = (isEdit ? `/dashboard/department/${this.props.id}` : '/dashboard/departments');

        return (
            <Form
                title={formTitle}
                onSave={this.onSave}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:40"
                            validationError="Please use only numbers and letters; at least 2, no more than 40"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            validations="maxLength:120"
                            validationError="Please use only numbers and letters"
                            hintText="Description"
                            floatingLabelText="Description"
                        />
                        {!isEdit && (
                            <SelectOrganisation
                                label="Organisation"
                                clearOnSelect={false}
                                maxSearchResults={10}
                                onSelect={this.onSelectOrganisation}
                            />
                        )}

                    </CardText>
                </Card>
            </Form>
        );
    }

    onSave(model) {
        model.organisationId = this.state.details.organisationId;
        if (!!this.props.id) {
            return DepartmentActions.update(this.props.id, model);
        } else {
            return DepartmentActions.save(model);
        }
    }

    onChange() {
        const details = DepartmentStore.getById(this.props.id);
        if (!!details) {
            this.setState({details});
        }
    }

    onSelectOrganisation(organisation, organisationId) {
        this.setState({details: {...this.state.details, organisationId, organisation}});
    }

}

export default withId(DepartmentForm);
